import { render } from "./SelectAddress.vue?vue&type=template&id=6e8222dd"
import script from "./SelectAddress.vue?vue&type=script&lang=js"
export * from "./SelectAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__